/**
 * SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/tenant-admin/TenantAdminDashboard.tsx
 * PURPOSE: SC-002-TA-HOME — Trang chủ Quản trị tổ chức (khung + tiêu đề, body TRỐNG)
 * SDLC FRAMEWORK VERSION: 6.3.1 (7-Pillar + 3-Section + 8-Mental-Model + Agentic)
 * PILLAR: P1 (Stage 04 - BUILD) + P6 (UI Components)
 * SPRINT GOVERNANCE: Rule 3: Zero-Mock Tolerance
 *
 * Release v0 WP-8: vùng nội dung ĐỂ TRỐNG theo mockup home.html — chỉ khung
 * (header + guard route) + page-head "Bảng điều khiển", chưa widget/thẻ số liệu.
 *
 * @business-context
 * - Domain: Tenant Administration, Vietnamese F&B
 * - Impact: Operational — landing page của Quản trị viên tổ chức
 * - Stakeholders: Tenant admins (IT/CIO/COO), tenant owners
 *
 * @technical-architecture
 * - Layer: Presentation Layer
 * - Pattern: Route guard (TENANT_ADMIN/TENANT_OWNER) + page shell
 * - Dependencies: React 18, useAuthStore
 *
 * @cross-references
 * - Mockup: docs/02-design/04-ui-ux-design/design-imports/ui-ux-nqhbot/v0/schedule/tenant-admin/home.html
 * - ADR: docs/02-design/18-adrs/06-decisions/DD-0002-three-tier-role-architecture.md
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/auth";

const TenantAdminDashboard: React.FC = () => {
  const { user, isAuthenticated, userRole } = useAuthStore();

  // Guard: only TENANT_ADMIN and TENANT_OWNER can access
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (userRole !== "TENANT_ADMIN" && userRole !== "TENANT_OWNER") {
    return <Navigate to="/dashboard/staff" replace />;
  }

  // ISS-0016 (2026-07-30): header tổ chức + Đăng xuất đã nằm trong sidebar của
  // TenantAdminLayout (SC-002 L515-541) — vùng nội dung CHỈ có tiêu đề vùng (D3).
  return (
    <div style={{ minHeight: "100vh", background: "var(--nqh-gray-100, #f3f4f6)" }}>
      {/* Content — v0: body TRỐNG, chỉ page-head "Bảng điều khiển" (mockup home.html [7]) */}
      {/* 2026-08-25 (UI-UX-DECISION-REGISTER.md luật 9, rollout): bỏ maxWidth
          1200px + margin:auto — kéo sát lề khả dụng ở Desktop. */}
      <main style={{ padding: "32px 24px" }}>
        <div style={{ marginBottom: "16px" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "var(--nqh-gray-900, #111827)",
              margin: 0,
            }}
          >
            Bảng điều khiển
          </h2>
        </div>
      </main>
    </div>
  );
};

export default TenantAdminDashboard;
